import Referrals from '@/modules/referrals'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/referrals')({
  component: Referrals,
})
